<template>
	<page>
		<module enable-flex>
			<m-search ref="search" @search="searchHandle">
				<c-form>
					<c-form-item type="input" label="单据号" name="record_number"></c-form-item>
                    <c-form-item type="input" label="会员手机号" name="user_manage_mobilephone"></c-form-item>
                    <c-form-item type="input" label="会员昵称" name="nick_name"></c-form-item>
					<c-form-item type="input" label="购买会员" name="level_name"></c-form-item>
					<c-form-item type="select" label="支付方式" name="payment_type" :options="paymentTypeOptions"></c-form-item>
					<c-form-item type="datetime" label="支付时间" start-name="begin_time" end-name="end_time"></c-form-item>
					 <c-form-item type="checkbox" label="支付状态" name="payment_state" :options="paymentStateOptions" ></c-form-item>
				</c-form>
			</m-search>
            <c-table ref="table">
                <!-- <c-table-column type="selector"></c-table-column> -->

                <c-table-column
                    label="单据号"
                    name="record_number"
                    width="140"
                ></c-table-column>

                <c-table-column
                        label="会员手机号"
                        name="user_manage_mobilephone"
                        width="120"
                ></c-table-column>

                <c-table-column
                        label="会员头像/昵称"
                        name="head_photo"
                        width="120"
                >
                    <template v-slot="{data}">
                        <div class="flex-center-cross">
                            <c-image :src="data.head_photo" preview size="30" style="margin-right: 10px;"></c-image>
                            <span>{{data.nick_name||'--'}}</span>
                        </div>
                    </template>
                </c-table-column>

                <c-table-column
                    label="交易金额"
                    name="money"
                    width="100"
                >
                    <template v-slot="{data}">
                        <span>￥{{(data.money||0).toFixed(2)}}</span>
                    </template>
                </c-table-column>

                <c-table-column
                    label="购买等级"
                    name="level_name"
                    width="100"
                >
                </c-table-column>

                <c-table-column
                    label="交易状态"
                    name="payment_state"
                    width="70"
                >
                  <template v-slot="{data}">
                    <span style="color:green" v-if="data.payment_state==2">已支付</span>
                    <span style="color:gray" v-if="data.payment_state==1">待支付</span>
                  </template>
                </c-table-column>

                <c-table-column
                    label="支付渠道"
                    name="payment_type"
                    width="70"
                >
                    <template v-slot="{data}">
                        <span v-if="data.payment_state==1">--</span>
                        <span v-else>{{data.payment_type}}</span>
                    </template>
                </c-table-column>

                <c-table-column
                    label="三方支付单号"
                    name="third_number"
                    width="230"
                >
                    <template v-slot="{data}">
                          <span v-if="data.third_number">{{data.third_number}}</span>
                          <span v-else>--</span>
                    </template>
                </c-table-column>
                <c-table-column
                    label="支付时间"
                    name="payment_date"
                    width="140"
                >
                    <template v-slot="{data}">
                        <span v-if="data.payment_date">{{data.payment_date}}</span>
                        <span v-else>--</span>
                    </template>
                </c-table-column>

                <c-table-column
                    type="button"
                    fixed="right"
                    label="操作"
                >
                    <template v-slot="{data}">
                        <c-table-button @click="navigateTo(`/membership_record/${data.id}`)">详情</c-table-button>
                    </template>
                </c-table-column>
            </c-table>
		</module>
	</page>
</template>

<script>
	import {mapState} from "vuex";
	export default {
		name: 'm_membership_record',
		
		data() {
			return {
                workType:15,
                searchParams:{},
				paymentTypeOptions: [
					{name: '余额',value: "余额"},
					{name: '微信',value: "微信"},
					{name: '支付宝',value: "支付宝"},
				],
				paymentStateOptions: [
					{name: '待支付',value: "1"},
					{name: '已支付',value: "2"}
				]
			}
		},

		computed: {
			...mapState(['systemConfig'])
		},

		mounted() {
			this.$refs.search.search();
			this.$bus.$on('m_membership_record.update', data => {
				// 刷新列表
				this.$refs.table.update();
			});
		},

		methods: {
			searchHandle(data) {
		        this.$refs.table.load({
					url: '/user/recharge/record/list',
					data
				});
                this.searchParams = data||{};
            },
            /**同步导出数据*/
            syncExport(){
                var selectDatas = this.$refs.table.getRow('selected');
                var order_ids = [];
                if (selectDatas.length && selectDatas.length>0) {
                    order_ids = Array.from(selectDatas, item => item.data.id);
                }
                this.request({
                    url: '/export/url',
                    data: Object.assign({
                        ids:order_ids,
                        work_type: this.workType //业务类型
                    },this.searchParams),
                    success: data => {
                        this.download({
                            fileName: data.filename,
                            url: data.url,
                            loading: {
                                message: '数据文件生成中...'
                            }
                        })
                    }
                });
            }
		}
	}
</script>